import React, { useState, useContext, useEffect } from 'react';
import './styles/Request.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from '../UserContext';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MdDelete } from "react-icons/md";
import { notifyError, notifySuccess, ToastContainer } from '../components/ErrorAlert';
import { NotifyMessages } from '../components/NotifyMessages';
import { IoMdArrowBack } from "react-icons/io";
import { openSecureFileUrl } from '../utils/fileAccess';

function CancelRequest() {
  const { user, token } = useContext(UserContext);
  const navigate = useNavigate();
  const { requestId } = useParams();

  const [reason, setReason] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/requests/booking-details/${requestId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch request data');
        }

        const data = await response.json();
        const cancelProof = data.cancelProof || '';
        const [proofName = '', proofUrl = ''] = cancelProof.split('$');

        setReason(data.cancelReason || '');
        setName(proofName);
        setUrl(proofUrl);
      } catch (error) {
        console.error('Error fetching request data:', error);
      }
    };

    fetchData();
  }, [requestId, token, user]);

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setName(uploadedFile.name);
      const temp = URL.createObjectURL(uploadedFile);
      setUrl(temp);
    }
  };

  const handleFileDelete = () => {
    setFile(null);
    setName('');
    setUrl('');
  };

  const handleExistingFileOpen = async (event, fileUrl) => {
    event.preventDefault();
    try {
      await openSecureFileUrl(fileUrl, token);
    } catch (error) {
      console.error('Failed to open secure cancel proof:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      await notifyError(NotifyMessages.cancelReasonRequired, 'bottom-center');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/requests/cancel-details/${requestId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ reason }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Network error: ${errorText}`);
      }

      await notifySuccess(NotifyMessages.cancelDetailsSubmitted, 'bottom-center');
      setFormSubmitted(true);
      setTimeout(() => navigate('/'), 2000);

    } catch (error) {
      console.error('Submit error:', error);
    }
  };

  useEffect(() => {
    if (formSubmitted && file) {
      const uploadFile = async () => {
        const formData = new FormData();
        formData.append('file', file);

        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/requests/cancel-details/upload/${requestId}`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
          });

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText);
          }

          const data = await response.json();
          const cancelProof = data.cancelProof || '';
          const [proofName = '', proofUrl = ''] = cancelProof.split('$');

          setName(proofName);
          setUrl(proofUrl);

        } catch (error) {
          console.error('Upload error:', error);
        }
      };

      uploadFile();
    }
  }, [formSubmitted, file, requestId, token]);


  return (
    <div className="Request">
      <Header />
      <ToastContainer />

      <main className="main-content">

        {/* 🔥 SCROLLABLE WRAPPER ADDED */}
        <div className="scroll-card">
          <div className="card-content">

            <div className="form-header">
              <div className="back-icon" onClick={() => navigate(-1)}>
                <IoMdArrowBack />
              </div>
            </div>

            <form className="reqForm" onSubmit={handleSubmit}>
              <h1>Cancel Request</h1>

              <fieldset>
                <label>
                  Cancel Reason:
                  <textarea
                    name="reason"
                    placeholder="Write your reason here..."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    style={{
                      display: 'block',
                      width: '100%',
                      height: '200px',
                      marginTop: '10px',
                      padding: '10px'
                    }}
                  />
                </label>

                <div className="upload">
                  <label htmlFor={`fileUpload_${requestId}`} className="upload-button">
                    <strong>Cancel Proof (optional):</strong>

                    {!name && !url && <FaCloudUploadAlt size={20} />}

                    <span>
                      {name && url ? (
                        <span className="view-download">
                          <a href={url} onClick={(e) => handleExistingFileOpen(e, url)}>
                            {name}
                          </a>
                        </span>
                      ) : (
                        <p className="upload-icon">Upload</p>
                      )}
                    </span>

                    <input
                      type="file"
                      id={`fileUpload_${requestId}`}
                      name="file"
                      onChange={(e) => handleFileUpload(e)}
                    />
                  </label>

                  {name && url && (
                    <span className="delete-upload">
                      <MdDelete onClick={handleFileDelete} />
                    </span>
                  )}
                </div>
              </fieldset>

              <button type="submit" className="submit-button">Submit</button>
            </form>

          </div>
        </div>
        {/* END scroll-card */}

      </main>

      <Footer />
    </div>
  );
}

export default CancelRequest;
